import { render, staticRenderFns } from "./AmerceList.vue?vue&type=template&id=47fe3bfa&"
import script from "./AmerceList.vue?vue&type=script&lang=js&"
export * from "./AmerceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports